/**
 * Polyfills for legacy browser support
 * This file is loaded before the main application to ensure
 * compatibility with older browsers (Chrome 64+, Safari 12+, Firefox 67+)
 */

// Core-js stable polyfills for ES5+ features
import 'core-js/stable';

// Regenerator runtime for async/await support
import 'regenerator-runtime/runtime';

// Polyfill for crypto.randomUUID() - added in Chrome 92
// Required for TinyMCE and other libraries on older browsers
if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
  crypto.randomUUID = function randomUUID(): `${string}-${string}-${string}-${string}-${string}` {
    return ('10000000-1000-4000-8000-100000000000').replace(/[018]/g, (c: any) => {
      const num = parseInt(c, 10);
      return (num ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> num / 4).toString(16);
    }) as `${string}-${string}-${string}-${string}-${string}`;
  };
}

// Polyfill for Promise.withResolvers() - added in Chrome 119 / Firefox 121
// Required for pdfjs-dist v4 on older browsers
// NOTE: Native support is detected in index.html <script> BEFORE modules load,
// because imports are hoisted and core-js would polyfill this before we could check.
if (typeof Promise !== 'undefined' && !(Promise as any).withResolvers) {
  (Promise as any).withResolvers = function withResolvers<T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: any) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

// Export empty object to make this a module
export {};
